/**
 * What is actually played, in one place.
 *
 * "8ball" was the BDIPL's name for it and the BDIPL was wrong: the game with
 * reds and yellows is blackball. The phone knew that and the wall tablet did
 * not — two lists of the same fact, and the tablet was still offering "8-ball"
 * months after the phone stopped.
 *
 * So: one list, imported by both. Killer is a venue game — several people
 * round one table — so it carries a flag rather than being a fourth entry in
 * a second list somewhere.
 */
export const FORMATS = [
  { id: 'blackball', label: 'Blackball' },
  { id: 'international', label: 'International' },
  { id: '9ball', label: '9-ball' },
  { id: 'killer', label: 'Killer', venueOnly: true },
  // The club's competition rather than a game: who is in the draw decides
  // who gets a trophy, so it is offered only where the venue says it may be.
  { id: 'knockout', label: 'Knockout', venueOnly: true, teamOnly: true },
];

/** The name for a stored id, which may be one this build no longer offers. */
export function nameOf(id) {
  return (FORMATS.find((f) => f.id === id) || {}).label || id;
}
